<template>
    <div id="NHSLookUp">
        <div class="d-flex flex-row justify-content-center" v-if="selectedView === 'loading'">
            <b-spinner class="brand-primary"></b-spinner>
        </div>
        <div class="content-container text-prompt-container" v-if="selectedView === 'search'">
            <h3 class="pb-5 brand-text align-self-center text-center question-title">Find your NHS GP surgery</h3>
            <p class="pb-3 text-center brand-text">Enter the name of your NHS GP surgery</p>
            <div class="search-container">
                <i class="fa-solid fa-magnifying-glass"></i>
                <input class="question-input w-100 mb-5" placeholder="Search..." v-model="searchInput">
            </div>
            <div class="py-3 px-4 error-container mb-4 text-left" v-if="showNhsErrors">
                <i class="fa-solid fa-triangle-exclamation mr-2"></i>
                Please enter at least three characters
            </div>
        </div>
        <div class="content-container text-prompt-container w-100" v-if="selectedView === 'error'">
            <h3 class="pb-5 brand-text align-self-center text-center question-title">Search results</h3>
            <div class="info-container d-flex flex-row align-items-start">
                <i class="brand-primary fa fa-info-circle fa-2x mr-4"></i>
                <div class="p-text">
                    <h4>We couldn't find your GP surgery</h4>
                    This could be because:
                    <ul>
                        <li>the surgery name is spelled differently</li>
                        <li>the address isn't quite right</li>
                    </ul>
                </div>
            </div>
            <div class="mt-5 text-center mb-5">
                <h4>I can't find my GP surgery</h4>
                <p class="p-text">If your GP surgery isn’t in the search results you can enter the address manually or
                    search again.</p>
            </div>
        </div>
        <div class="content-container text-prompt-container mb-5 w-100" v-if="selectedView === 'results'">
            <h3 class="pb-5 brand-text align-self-center text-center question-title">Search results</h3>
            <div class="mb-3 org-button d-flex flex-row align-items-center justify-content-between"
                v-for="org in organisations" @click="$emit('manual-entry', org, searchInput)">
                <div>
                    <h4 class="mb-2">{{ org.name }}</h4>
                    <p>{{ org.address }}<span v-if='org.town'>, {{ org.town }}</span><span v-if="org.post_code">,
                            {{ org.post_code }}</span></p>
                </div>
                <i class="fa-solid fa-chevron-right"></i>
            </div>
            <div class="d-flex justify-content-center align-items-center mb-5" v-if='loadingResults'>
                <b-spinner class="brand-primary mt-5 mb-5" />
            </div>
        </div>
        <div class="button-row" v-if="selectedView !== 'loading'">
            <b-button variant="cta-outline" size="lg" squared @click="previousQuestion()">Previous</b-button>
            <b-button variant="cta-outline" size="lg" squared @click="$emit('manual-entry')" :disabled="search === ''"
                v-if="selectedView === 'results' || selectedView === 'error'">Enter surgery address manually</b-button>
            <b-button variant="cta-outline" size="lg" squared @click="previousQuestion()" :disabled="search === ''"
                v-if="selectedView === 'error'">Search again</b-button>
            <b-button variant="cta" size="lg" squared @click="search()" :disabled="search === ''"
                v-if="selectedView === 'search'">Search</b-button>

        </div>
    </div>
</template>
<script>

import axios from "axios"
import config from "../../config/constants"
import moment from "moment";

export default {
    components: {
    },
    name: "NHSLookUp",
    data() {
        return {
            searchInput: '',
            organisations: [],
            selectedView: 'loading',
            loadingResults: true,
            noResults: false,
            showNhsErrors: false,
        };
    },
    mounted() {
        if (this.initialSearchTerm) {
            this.searchInput = this.initialSearchTerm;
            this.search();
        } else {
            this.selectedView = 'search';
        }
    },
    beforeDestroy() {

    },
    methods: {
        previousQuestion() {
            if (this.selectedView === 'search') {
                this.$emit('previous-question');
            } else if (this.selectedView === 'results') {
                this.organisations = [];
                this.selectedView = 'search';
            } else if (this.selectedView === 'error') {
                this.organisations = [];
                this.selectedView = 'search';
            }
            this.scrollToRef();
        },
        search() {
            this.getOrgs();
        },
        async getOrgs() {
            if (this.searchInput.length < 3) {
                this.showNhsErrors = true;
            } else {
                let self = this;
                this.noResults = false;
                const payload = {
                    user_id: this.$store.getters.user_id,
                    search: this.searchInput
                };
                let res = await axios.post(
                    config.api_env + "/application/api/u/nhs/get-organizations",
                    payload,
                    config.options
                );
                if (res.data.success) {
                    let counter = 0
                    this.loadingResults = true;
                    if (res.data.organizations.length > 0) {
                        res.data.organizations.forEach((org) => {
                            counter++;
                            self.getOrg(org.org_id, counter === res.data.organizations.length);
                        })
                        this.selectedView = 'results';
                    } else {
                        this.selectedView = 'error';
                    }

                }
            }

        },
        async getOrg(code, lastOrg) {
            let self = this;
            const payload = {
                user_id: this.$store.getters.user_id,
                org_id: code
            };
            let res = await axios.post(
                config.api_env + "/application/api/u/nhs/get-organization-details",
                payload,
                config.options
            );
            if (res.data.success) {
                if (lastOrg) {
                    this.loadingResults = false;
                }
                this.organisations.push(res.data.organizations);
            }
        }
    },
    watch: {
        searchInput(newValue) {
            if (newValue.length >= 3) {
                this.showNhsErrors = false;
            }
        }
    },

    props: ['question', 'updateAnswer', 'loadedAnswer', 'dateError', 'initialSearchTerm'],
};
</script>
<style lang="less">
#NHSLookUp {
    display: flex;
    flex-direction: column;
    justify-content: center;

    p {
        font-size: 1.6rem;
    }

    .question-title {
        padding-top: 0;
        margin-top: 0;
        letter-spacing: normal;
        font-size: 1.8rem;
        text-align: center;
    }

    .org-button {

        width: 100%;
        border-radius: 12px;
        background-color: white;
        padding: 15px 20px;
        border: 2px solid white;

        h4 {
            font-weight: 400;
        }

        p {
            color: #21272A;
            margin-bottom: 0;
            padding-bottom: 0;

        }
    }

    .info-container {
        font-family: "Montserrat", serif;
        background-color: white;
        padding: 20px;
        border: 2px solid #0079c8;
        border-radius: 16px;
        margin-bottom: 25px;
    }

    .org-button:hover {
        cursor: pointer;
        border: 2px solid #0079c8;

        h4 {
            text-decoration: underline;
        }
    }

    .search-container {
        position: relative;

        i {
            position: absolute;
            top: 14px;
            left: 15px;
            font-size: 1.8rem;
        }
    }

    .question-input {
        border-radius: 24px;
        border: 1px solid #dde1e6;
        margin-bottom: 20px;
        padding: 10px 20px;
        font-size: 1.6rem;
        padding-left: 40px;
    }

    .text-prompt-container {
        max-width: 700px;
        font-size: 1.6rem;

        h3 {
            padding-top: 0;
            margin-top: 0;
            letter-spacing: normal;
            font-size: 1.8rem;
        }

        .warning-info-container {
            font-family: "Montserrat", serif;
            font-weight: 700;
            background-color: white;
            padding: 20px;
            border: 2px solid #D60023;
            border-radius: 16px;
            margin-bottom: 25px;

            i {
                color: #D60023;
            }
        }

        .btn {
            margin-top: 30px;
            margin-bottom: 100px;
        }

        .error-container {

            width: 100%;
            background-color: #fbeacf;
            border-radius: 6px;

            i {
                color: red;
            }
        }
    }

    .text-remaining {
        padding-top: 5px;
        float: right;
        width: 100%;
        text-align: right;
        font-size: 1.4rem;
        color: #aaa;
        padding-bottom: 10px;
    }


    .text-remaining {
        padding-top: 5px;
        width: 100%;
        text-align: right;
        font-size: 1.4rem;
        color: #aaa;
        padding-bottom: 10px;
    }

    textarea {
        border-radius: 6px;
        padding: 5px;
        border: 1px solid #dde1e6;
        resize: none;
    }

    .error-container {
        font-size: 1.6rem;
        width: 100%;
        background-color: #fbeacf;
        border-radius: 6px;

        i {
            color: red;
        }
    }
}
</style>